export enum DataType {
    NUMBER = "number",
    TEXT = "text",
    DATE = "date",
    BOOLEAN = "boolean",
    SELECT = "select",
}